<div *ngIf="element.url" class="mouse-over" style="position:relative">
  <div style="display: flex; flex-direction: row; position: relative; width: fit-content; height: fit-content; padding: 0px;">
    <video 
      #videoPlayer
      [id]="'video'+element.entryId" 
      [autoplay]="hasStarted()" 
      (play)="playing()" 
      (timeupdate)="onTimeUpdate()" 
      (ended)="ended()" 
      (pause)="notPlaying()" 
      [controls]="!isLimitted || element.enableVideoControls" 
      (seeked)="onSeeking()"
      [width]="640 * getZoom()" 
      [height]="480 * getZoom()" 
      [controlsList]="getVideoControlList()" 
      (canplay)="canStartPlaying()"
      (loadedmetadata)="loadedMetaData()"
      disablePictureInPicture
      preload="auto"
      crossorigin="anonymous"
      [class.is-hide-timeline]="hideVideoControlTimeline()"
      [class.is-hide-play-button]="hideVideoControlPlayButton()"
      (ratechange)="onPlaybackSpeedChange()"
    >

      <source *ngFor="let video of videoSourceUrls " [type]="video.type" [src]="video.src">
      <track *ngIf="allowSubtitles && accommodation==1"
             default
             kind="subtitles"
             [srclang]="getSubtitleTracks()[0].srclang"
             [src]="getSubtitleTracks()[0].src"
             type="text/vtt"
             [label]="getSubtitleTracks()[0].label">
    </video> 
  </div>
  
  <div *ngIf="isLimitted && !element.enableVideoControls" style="position:absolute; position:absolute;left:0px; right:0px; top:0px; bottom:0px; display: flex; justify-content: center; align-items: center;">
    <!--<tra-md [isCondensed]="true" slug="lbl_num_views_left" [props]="{NUM_REM_VIEWS: element.maxViews - questionState[element.entryId].numViews}"></tra-md>-->
    <button *ngIf="!isPlaying" (click)="play()" style="font-size:4em;">
      <i class="fas fa-play-circle"></i>
    </button>
    <button class="on-mouse-over-pause-button" *ngIf="isPlaying && !element.isUnPausable" (click)="pause()" style="font-size:4em;">
      <i class="fas fa-pause-circle"></i>
    </button>
    <div class="on-mouse-over" [style.opacity]="element.showMouseOverToolTip? 1 : 0">
      <div *ngIf="!element.isAlwaysShowingTime" class="video-info-display">
        <div *ngIf="resetter && this.questionState && this.questionState[element.entryId] && element.maxViews">
          <tra-md  [isCondensed]="true" [slug]="getNumberOfViewsLeftSlug()" [props]="{NUM_REM_VIEWS: element.maxViews - questionState[element.entryId].numViews}"></tra-md>
        </div>
        <div>
            {{getSecRemainingStr()}} <tra [slug]="getSecondsRemainingSlug()"></tra>
        </div>
      </div>
      <div *ngIf="element.maxViews > 0 || element.isUnPausable" #videoTooltip (click)="dismissTooltip()" class="video-tool-tip" 
        [class.tool-tip-show]="isTooltipVisible || element.showMouseOverToolTip" 
        [class.tool-tip-hide]="!isTooltipVisible && !element.showMouseOverToolTip"
        [ngStyle]="getToolTipContainerStyle()"
        >
        <ng-container *ngIf="element.maxViews > 0">
          <p><tra-md [isCondensed]="true" slug="video_tooltip_max_views" [props]="{MAX_VIEWS: element.maxViews}"></tra-md></p>
        </ng-container>
        <ng-container *ngIf="element.isUnPausable">
          <p><tra slug="video_tooltip_unpausable"></tra></p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isLimitted && element.isAlwaysShowingTime && !element.enableVideoControls" class="video-info-display" >
  <div>
    <tra-md *ngIf="resetter && this.questionState && this.questionState[element.entryId] && element.maxViews" [isCondensed]="true" [slug]="getNumberOfViewsLeftSlug()" [props]="{NUM_REM_VIEWS: element.maxViews - questionState[element.entryId].numViews}"></tra-md>
  </div>
  <div>{{getSecRemainingStr()}} <tra [slug]="getSecondsRemainingSlug()" ></tra></div>
</div><br>
<button *ngIf="element.allowFullScreen" (click)="fullScreen()">
  <tra slug="btn_video_fullscreen_BCED"></tra>
</button>
<div *ngIf="allowPlaybackSpeed">
  <tra-md [isCondensed]="true" slug="bc_authoring_view_playbackrate"></tra-md>
  <div class="control is-expanded">
    <div class="select">
      <select *ngIf="!isFrench()" [(ngModel)]="playBackRate" (ngModelChange)="adjustRate()">
        <option *ngFor="let rate of playBackRates; let index = index" [value]="rate">
          {{rate}}
        </option>
      </select>
      <select *ngIf="isFrench()" [(ngModel)]="playBackRate_fr" (ngModelChange)="adjustRate_fr()">
        <option *ngFor="let rate of playBackRates_fr; let index = index" [value]="rate">
          {{rate}}
        </option>
      </select>
    </div>
  </div>  
</div>
<div *ngIf="allowTranscripts && accommodation==1" class="transcript">
  <button *ngIf="transcriptUrl" (click)="showTranscript()" class="transcript-toggle">
    {{transcriptOn ? 'Hide Transcript' : 'Show Transcript'}}
  </button>
  <div [innerHtml]="transcript" *ngIf="transcriptOn && transcriptUrl" class="transcript-content">
</div>
  
</div>

